export const ORGANIZATION_UNITS_KEYS = {
  all: ['organization-units'] as const,
  byOrg: (orgId: string) => ['organization-units', orgId] as const,
  list: (orgId: string) => ['organization-units', orgId, 'list'] as const,
  orgChart: (orgId: string) => ['organization-units', orgId, 'org-chart'] as const,
  orgChartProjects: (orgId: string) => ['organization-units', orgId, 'org-chart-projects'] as const,
  memberSummary: (orgId: string, memberId: string) =>
    ['organization-units', orgId, 'member-summary', memberId] as const,
};
